import { ReactComponent as EditSVG } from '../assets/editIcon.svg';

export default function EditPencil() {
  return (
    <div className='group flex cursor-pointer text-gray-400 hover:text-gray-800 duration duration-300'>
      <EditSVG className='flex cursor-pointer fill-current text-gray-400 hover:text-gray-800 duration duration-300' />
    </div>
  );
}
